import { Box ,Tooltip,FormControl, MenuItem, Select} from "@mui/material";
import { editGrnRowsData } from "../../types/types";
import { truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";
import { TruncatedTextUptoLine } from "../../components/dms_common/DmsUtils";
import { ReactComponent as CircledRight } from "../../assets/image/svg/circledRight.svg";
export const getViewGrnDetailsConfig = (
  toggleTaxInfoCollapsedStatus: (
    paramRow: editGrnRowsData,
    collapsed: boolean
  ) => void,
  grnStatus: string,
  remarks:boolean,
  handlePromotionModalVisibility: (paramRow: editGrnRowsData) => void,
  showPricePerPiece: boolean,
  showTaxPercentage: boolean = true,
) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimary,caseUnitLabelPrimary,otherUnitLabelPrimary,currency, batchIdConfiguration = false } = ConfigDictionary;

  return {
  columns: [
    {
        headerName: "skuNameAndCode",
        mappedValue: "batchCode",
        width: 180,
        renderHeader: (value: any) => (
          <Box display="flex" sx={{ flexDirection: "column", alignItems: "left" }}>
                    <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                      <span>{"SKU Name"}</span>
                      <span className="customTableInfo_marginTopNegative">{"& Code"}</span>
                    </Box>
                  </Box>
        ),
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={`${row?.skuDescription} - ${value}`}>
              <Box className="sku_name_truncate_text ViewOrderConfig_skuCode">
                {row?.freeItem && (
                  <span className="ViewOrderConfig_freeText">FREE</span>
                )}
                <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                  <span style={{ ...TruncatedTextUptoLine(1), fontWeight: 500, fontSize: "13px" }}>
                    {row?.skuDescription}
                  </span>
                  <span style={{ ...TruncatedTextUptoLine(1), fontSize: "12px", color: "#666" }}>
                    {value}
                  </span>
                </div>
              </Box>
            </Tooltip>
          );
        },
      },
    ...( batchIdConfiguration) ? [
        {
          headerName: "Batch Id",
          mappedValue: "batchId",
          width: 100,
          renderHeader: (value: any) => (
            <Box display={"flex"} flexDirection={"column"}>
              <span>{"Batch ID"}</span>
            </Box>
          ),
          renderCell: (value: any, row: any) => {
              return (
                <Tooltip title={value}>
                  <Box className="sku_name_truncate_text">
                    <span style={TruncatedTextUptoLine(2)}>{value ?? "-"}</span>
                  </Box>
                </Tooltip>
              );
            },
        }
      ] : [],
 
     {
      headerName: "Promotion",
      mappedValue: "promotion",
      width: 115,
      renderCell: (value: any, row: any) => {
        if (+row?.discount === 0) return <>-</>;
        return (
          <div
            className="view-discounts-container"
            onClick={() => handlePromotionModalVisibility(row)}
          >
            <span>View Promos</span>
            <CircledRight style={{ width: "10px" }} />
          </div>
        );
      },
    },
    
    ...(caseUnitLabelPrimary
      ? [
          {
            headerName: "Cases",
            mappedValue: "qtyCase",
            width: 60,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Qty"}</span>
                  <span>{`(${caseUnitLabelPrimary})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
        ]
      : []),
    ...(otherUnitLabelPrimary
      ? [
          {
            headerName: "Others",
            mappedValue: "qtyOtherUnit",
            width: 60,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Qty"}</span>
                  <span>{`(${otherUnitLabelPrimary?.slice(0, 3)})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
        ]
      : []),
    ...(packUnitLabelPrimary
      ? [
          {
            headerName: "Pieces",
            mappedValue: "qtyPiece",
            width: 60,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Qty"}</span>
                  <span>{`(${packUnitLabelPrimary})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
        ]
      : []),


    {
      headerName: "Price (Each Cs)",
      mappedValue: "pricePerCase",
      width: 100,
      textAlign: "left",
      currencySymbol: currency,
      renderHeader: (value: any) => (
        <Box
          display={"flex"}
          sx={{ flexDirection: "column", alignItems: "left" }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            sx={{ textAlign: "left" }}
          >
            <span>{"Price"}</span>
            <span>{"(Each Cs)"}</span>
          </Box>
        </Box>
      ),
    },

    ...(showPricePerPiece
      ? [
    {
      headerName: "Price (Each Pc)",
      mappedValue: "piecePrice",
      width: 100,
      textAlign: "left",
      currencySymbol: currency,
      renderHeader: (value: any) => (
        <Box
          display={"flex"}
          sx={{ flexDirection: "column", alignItems: "left" }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            sx={{ textAlign: "left" }}
          >
            <span>{"Price"}</span>
            <span>{"(Each Pc)"}</span>
          </Box>
        </Box>
      ),
    },
    ]
  : []),

    { headerName: "Amount", mappedValue: "actualAmount",textAlign: "left", width: 100,
      renderCell: (value: any) => (
        <span>{currency ?? ""}{truncateToTwoDecimals(Number(value))}</span>
      )
     },
    {
      headerName: "Discount",
      mappedValue: "discount",
      currencySymbol: currency,
      width: 80,
      textAlign: "left",
    },
    {
      headerName: "Tax Amount & (%)",
      mappedValue: "taxInfo",
      width: 160,
      textAlign: "left",
      renderHeader: (value: any) => (
        <Box
          display={"flex"}
          sx={{ flexDirection: "column", alignItems: "left" }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            sx={{ textAlign: "left" }}
          >
            <span>{"Tax"}</span>
            <span>{`Amount ${showTaxPercentage ? "& (%)" : ""}`}</span>
          </Box>
        </Box>
      ),
      renderCell: (value: any, row: any) => {
        const isCollapsed = row.collapsed;

        const aggregateTaxAmount = value?.reduce((acc:any,curr:any)=>{
          acc += Number(curr?.taxAmount)
          return acc
        },0)

        const aggregateTaxPercent = value?.reduce((acc:any,curr:any)=>{
          acc += Number(curr?.taxPercent)
          return acc
        },0)

        const consolidatedTaxObj = {taxType:"All", taxAmount:aggregateTaxAmount, taxPercent:aggregateTaxPercent ?? "",};

        return (
          <FormControl className="manage_order_filter">
          <Select
            labelId="dropdown_label"
            size="small"
            displayEmpty
            sx={{
              "& .MuiSelect-select": {
                padding: "0px !important",
              },
              width: "100%",
              fontSize: "14px",
              padding: "0px",
              "&.Mui-focused": {
                boxShadow: "none",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              
              "& .MuiSelect-icon": {
                display: value.length === 0 ? "none" : "block",
                marginRight: "-11px" 
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  mt: 1,
                  padding: 0,
                  boxShadow: "none",
                  border: "1px solid #DEDEDE",
                  borderRadius: "8px",
                },
              },
              MenuListProps: {
                sx: {
                  padding: "7px 0",
                },
              },
            }}
            renderValue={() => {
              return (
                <span style={{ color: "#7c7c7c", fontSize: "13px" }}>
                  <span>
                    {`${consolidatedTaxObj?.taxType ?? ""}: ${
                      currency ?? ""
                    }\u200A${truncateToTwoDecimals(consolidatedTaxObj?.taxAmount ?? 0)}`}
                    {showTaxPercentage && `(${consolidatedTaxObj?.taxPercent ?? 0}%)`}
                  </span>
                </span>
              );
            }}
          >
            
            {value.length > 0 && value.map((item: any, index: any, arr: any) => (
              <MenuItem
                key={item?.taxType}
                value={item?.taxType}
                className="menuItem-test-debug"
                sx={{
                  padding: "2px 0px",
                  borderBottom:
                    index !== arr.length - 1
                      ? "1.5px dashed #EBEBEB"
                      : "none",
                  margin: "0 10px",
                  pointerEvents: "none"
                }}
              >
                <div className="loadout_dropdown_menu_item">
                  <span>
                    {`${item?.taxType ?? ""}: ${currency ?? ""}${truncateToTwoDecimals(
                      item?.taxAmount ?? 0
                    )}`}
                    {showTaxPercentage && `(${item?.taxPercent ?? 0}%)`}
                  </span>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        
        );


      },
    },

    ...(caseUnitLabelPrimary && (grnStatus === "PARTIALLY_REJECTED" || remarks)
      ? [
          {
            headerName: "",
            mappedValue: "initialCaseQuantity",
            width: 110,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Accepted"}</span>
                  <span>{`Qty (${caseUnitLabelPrimary})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
          {
            headerName: "",
            mappedValue: "rejectedCaseQuantity",
            width: 110,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Rejected"}</span>
                  <span>{`Qty (${caseUnitLabelPrimary})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
        ]
      : []),
    ...(otherUnitLabelPrimary && (grnStatus === "PARTIALLY_REJECTED" || remarks)
      ? [
          {
            headerName: "",
            mappedValue: "initialOtherUnitQuantity",
            width: 110,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Accepted"}</span>
                  <span>{`Qty (${otherUnitLabelPrimary?.slice(0, 3)})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
          {
            headerName: "",
            mappedValue:"rejectedOtherUnitQuantity",
            width: 110,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Rejected"}</span>
                  <span>{`Qty (${otherUnitLabelPrimary?.slice(0, 3)})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
        ]
      : []),
    ...(packUnitLabelPrimary && (grnStatus === "PARTIALLY_REJECTED" || remarks)
      ? [
          {
            headerName: "",
            mappedValue: "initialPieceQuantity",
            width: 110,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Accepted"}</span>
                  <span>{`Qty (${packUnitLabelPrimary})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
                    {
            headerName: "",
            mappedValue: "rejectedPieceQuantity",
            width: 110,
            textAlign: "center",
            renderHeader: () => (
              <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                  <span>{"Rejected"}</span>
                  <span>{`Qty (${packUnitLabelPrimary})`}</span>
                </Box>
              </Box>
            ),
            renderCell: (value: any) => (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="view_order_pack_quantity_input style_adjust">{value}</div>
              </Box>
            ),
          },
        ]
      : []),




    {
      headerName: "Final Amount",
      mappedValue: "finalAmount",
      width: 100,
      textAlign: "left",
      currencySymbol: currency,
      renderHeader: (value: any) => (
        <Box
          display={"flex"}
          sx={{ flexDirection: "column", alignItems: "left" }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            sx={{ textAlign: "left" }}
          >
            <span>{"Final"}</span>
            <span>{"Amount"}</span>
          </Box>
        </Box>
      ),
      renderCell: (value: any) => (
        <Box>
          <span
            style={{
              textAlign: "left",
              fontWeight: 600,
            }}
          >
            {`${currency}\u200A${value ?? ""}`}
          </span>
        </Box>
      )
    },
    ...((grnStatus === "PARTIALLY_REJECTED" || remarks)
      ? [
    {
      headerName: "",
      mappedValue: "skuRejectionReason",
      width: 180,
      renderHeader: (value: any) => (
        <Box display={"flex"} flexDirection={"column"}>
          <span>{"Rejection"}</span>
          <span>{"Reason"}</span>
        </Box>
      ),
      renderCell: (value: any) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span style={TruncatedTextUptoLine(2)}>{value}</span>
              </Box>
            </Tooltip>
          );
        },
    },
  ]
  : []),

  ],
};
}

const getQuantityLabels = () => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimary,caseUnitLabelPrimary,otherUnitLabelPrimary } = ConfigDictionary;

   
  const labels: string[] = [
    caseUnitLabelPrimary ? `${caseUnitLabelPrimary}` : "",
    otherUnitLabelPrimary ? `${otherUnitLabelPrimary}` : "",
    packUnitLabelPrimary ? `${packUnitLabelPrimary}` : ""
  ].filter(Boolean); // Removes empty strings
  
    return labels.length > 0 ? `Qty (${labels.join(", ")})` : "Qty";
  };

export const getMetaData1 = (currencySymbol: string): any[] => [
  {
    keys: "totalCasePieceOtherQuantity",
    label: getQuantityLabels(),
    index: 1,
    valueType: "String",
  },
  {
    keys: "totalQuantity",
    label: "Total Products",
    index: 2,
    valueType: "Number",
  },
  {
    keys: "initialAmount",
    label: "Total Amount",
    index: 3,
    valueType: "Number",
    currencySymbol : currencySymbol,
  },
  {
    keys: "discountValue",
    label: "Discount Value",
    index: 4,
    valueType: "Number",
    currencySymbol : currencySymbol,
  },
  {
    keys: "taxAmount",
    label: "Tax Amount",
    index: 5,
    valueType: "Number",
    currencySymbol : currencySymbol,
  },
  {
    keys: "netAmount",
    label: "Final Amount",
    index: 6,
    valueType: "Number",
    currencySymbol : currencySymbol,
    focusField: true,
  },
];

export const metaData2 = (): any[] => {
  let metadata = [{
    keys: "supplierCode",
    label: "Supplier Code",
    index: 1,
    removeEllipsis: false,
    truncateTextAfterChar: 43,
  },
  {
    keys: "supplierName",
    label: "Supplier Name",
    index: 2,
    removeEllipsis: false,
    truncateTextAfterChar: 43,
  },
  {
    keys: "deliveryDate",
    label: "Est. Delivery Date",
    index: 3,
    removeEllipsis: true,
  }]

  let grnDeliveryData = [
    {
      keys: "dispatchDate",
      label: "Dispatch Date",
      index: 4,
      valueType: "String",
      removeEllipsis: true,
    },
    {
      keys: "grnActionTime",
      label: "GRN Date and Time",
      index: 5,
      valueType: "String",
      removeEllipsis: true,
    },
    {
      keys: "vehicleNumber",
      label: "Vehicle No.",
      index: 6,
      valueType: "String",
      removeEllipsis: true,
    },
    {
      keys: "driverName",
      label: "Driver Name",
      index: 7,
      valueType: "String",
      removeEllipsis: true,
    },
    {
      keys: "driverMobile",
      label: "Driver Mobile",
      index: 8,
      valueType: "String",
      removeEllipsis: true,
    },
    
  ];
    metadata = [...metadata, ...grnDeliveryData];
  
  return metadata;
}
